export const Breakpoints = {
    /* generic breakpoints to determine a device category i.e., mobile | tablet | desktop */
    TABLET: 768,
    LAPTOP: 1200,
    DESKTOP: 1366,

    /* breakpoints based on component's width */
    COURSE_CATALOGUE: 1200,
    DASHBOARD: 1100,
    DASHBOARD_COMPACT: 600,
};
